export default {"src":"/_next/static/image/src/atoms/Checkbox/Checkmark-disabled.555ce7e9d2792b255e1cddff7db3dc8a.svg","height":14,"width":15};